import React, {ReactElement, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {NavLink as RouterLink} from 'react-router-dom';
import {getUserInfo} from '../../../../../shared/src/services/UserService';
import {_logout} from '../../../../../shared/src/store/actions/AuthActions';

import AuthUtils from '../../../utils/AuthUtils';
import NavRoutes from '../../../constants/NavRoutes';
import Logo from '../../../assets/images/mpower-white-icon.svg';
import Logout from '../../../assets/images/logout.svg';
import './Topbar.scss';
import {BASE_ROUTE} from '../../../constants/BaseRoute';

const Topbar = (props: any): ReactElement => {
  const {t} = useTranslation();
  const userObject: any = AuthUtils.getUser();
  const userName: any = (userObject && userObject.name) || t('COMMON.NA');
  const [userType, setUserType] = React.useState<string>('');
  const [userModules, setUserModules] = React.useState<string[]>([]);

  useEffect(() => {
    getUserInfo().then(userInfo => {
      const user = userInfo?.user || userInfo;
      AuthUtils.setUserType(user.user_type);
      const UserType = AuthUtils.getUserType();
      setUserType(UserType as string);
      setUserModules(userInfo?.modules || []);
    });
  }, []);

  const handleLogout = (): void => {
    AuthUtils.clearAuthToken();
    AuthUtils.clearUser();
    AuthUtils.clearUserType();
    props._logout();
  };
  const isSuperAdmin = ['super_admin', 'admin'].includes(userType);
  const canViewTab = (moduleNameId: string): boolean =>
    isSuperAdmin || userModules.includes(moduleNameId);
  return (
    <div className="top-bar-wrapper">
      <div className="image-container">
        <img alt="Logo" src={Logo} className="logo-image" />
      </div>
      <div style={{
        width:  isSuperAdmin ? '5%' : '0%',
        visibility: isSuperAdmin ? 'visible' : 'hidden',
      }}>
        <RouterLink
          to={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.USERS}`}
          activeClassName="current">
          <span className="users-text">{t('USERS.USERS')}</span>
        </RouterLink>
      </div>
      <div
        style={{
         width:  canViewTab('interpreting_physicians') ? '15%' : '0%',
         visibility: canViewTab('interpreting_physicians') ? 'visible' : 'hidden',
        }}>
        <RouterLink
          to={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.INTERPRETING_PHYSICIANS}`}
          activeClassName="current">
          <span className="users-text">
            {t('INTERPRETINGPHYSICIANS.INTERPRETINGPHYSICIANS')}
          </span>
        </RouterLink>
      </div>

      <div
        style={{
          width:  canViewTab('cases') ? '5%' : '0%',
          visibility: canViewTab('cases') ? 'visible' : 'hidden',
        }}>
        <RouterLink
          to={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.CASES}`}
          activeClassName="current">
          <span className="users-text">Cases</span>
        </RouterLink>
      </div>
      <div style={{
          width:  canViewTab('surgeons') ? '6%' : '0%',
          visibility: canViewTab('surgeons') ? 'visible' : 'hidden',
        }}>
        <RouterLink
          to={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.SURGEONS}`}
          activeClassName="current">
          <span className="users-text">
            Surgeons
          </span>
        </RouterLink>
      </div>
      <div
        style={{
          width: canViewTab('surgeon_forms') ? '10%' : '0%',
          visibility: canViewTab('surgeon_forms') ? 'visible' : 'hidden'
        }}
      >
        <RouterLink
          to={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.SURGEON_FORMS}`}
          activeClassName="current"
        >
          <span className="users-text">Surgeon Forms</span>
        </RouterLink>
      </div>
      <div
        style={{
          width:  canViewTab('configurations') ? '10%' : '0%',
          visibility: canViewTab('configurations') ? 'visible' : 'hidden',
        }}>
        <RouterLink
          to={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.CONFIGURATIONS}`}
          activeClassName="current">
          <span className="users-text">Configurations</span>
        </RouterLink>
      </div>

      <div
        style={{
          width:  canViewTab('patients') ? '6%' : '0%',
          visibility: canViewTab('patients') ? 'visible' : 'hidden',
        }}>
        <RouterLink
          to={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.PATIENTPORTAL}`}
          activeClassName="current">
          <span className="users-text">Patients</span>
        </RouterLink>
      </div>

      <div className="topbar-right-section">
        <div className="user-name-container">
          <span className="users-text">{t('USERS.LOGGEDINAS') + userName}</span>
        </div>

        <div className="vertical-seperator">
          <span className="users-text">{'|'}</span>
        </div>

        <div className="logout-container" onClick={handleLogout}>
          <div className="logout-view">
            <img alt="Logout" src={Logout} className="logout-image" />
            <span className="users-text">{'Logout'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, { _logout })(Topbar);